import {version} from '../../package.json';

export default {
  install: (app) => {
    app.config.globalProperties.$version = version;
  }
}